<template>
  <svg width="23" height="20" viewBox="0 0 23 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M22.856 10a1.428 1.428 0 0 1-1.429 1.428H4.88l6.133 6.13a1.43 1.43 0 0 1-2.023 2.023l-8.57-8.57a1.427 1.427 0 0 1 0-2.022L8.99.419a1.43 1.43 0 0 1 2.023 2.022l-6.133 6.13h16.548A1.428 1.428 0 0 1 22.856 10z"
      :fill="color"
    />
  </svg>
</template>

<script lang="ts" setup>
withDefaults(defineProps<{ color?: string }>(), { color: '#16780b' });
</script>
